import React from 'react';
import {IconType} from '../../icons/icons';
import classNames from 'clsx';
import {SvgIcon} from '../../icons/svgIcon';
import {OverlayTrigger} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {UpdatingTooltip} from './hibuUpdatingTooltip';

type HibuOverlayProps = {
    className?: string;
    onClick: (ref: React.Ref<any>, e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    resetFunction?: () => void;
    icon: IconType;
    tooltipKey: string;
    size?: 'sm' | 'md';
    disabled?: boolean;
};

export const HibuOverlay = React.memo(({
                                           className,
                                           onClick,
                                           resetFunction,
                                           icon,
                                           tooltipKey,
                                           size = 'md',
                                           disabled
                                       }: HibuOverlayProps) => {
    const {t} = useTranslation();

    return (
        <OverlayTrigger
            onExited={resetFunction}
            overlay={<UpdatingTooltip tooltipKey={tooltipKey}>{t(tooltipKey)}</UpdatingTooltip>}
        >
            {({ref, ...triggerHandler}) => (
                <button
                    {...triggerHandler}
                    className={classNames('hibu-button', className, size)}
                    ref={ref}
                    onClick={(e) => onClick(ref, e)}
                    disabled={disabled}
                >
                    <SvgIcon icon={icon}/>
                </button>
            )}
        </OverlayTrigger>
    );
});
